var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    fill: "currentColor",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.5 36.25v-22.5A3.745 3.745 0 0 0 43.75 10H8.725a3.745 3.745 0 0 0-3.75 3.75v22.5A3.745 3.745 0 0 0 8.725 40H43.75a3.745 3.745 0 0 0 3.75-3.75Zm-3.275-22.775c.825.825.375 1.675-.075 2.1L34 24.875l9.75 10.15c.3.35.5.9.15 1.275-.325.4-1.075.375-1.4.125L31.575 27.1l-5.35 4.875L20.9 27.1 9.975 36.425c-.325.25-1.075.275-1.4-.125-.35-.375-.15-.925.15-1.275l9.75-10.15-10.15-9.3c-.45-.425-.9-1.275-.075-2.1.825-.825 1.675-.425 2.375.175l15.6 12.6 15.625-12.6c.7-.6 1.55-1 2.375-.175Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.13e86b8f215ac43eaa0f457c3c4c90ca.svg";
export { ForwardRef as ReactComponent };